import { useAppDispatch } from "JS/Redux/Store";
import { RetiredContentService } from "JS/Services/RetiredContent";
import { useSnackbar } from "JS/Helpers/Snackbar";
import { useCallback, useEffect, useState } from "react";
import { useGlobalMediaEssentials } from "./MediaEssentials";
import { setRetiredAudios, setRetiredVideos } from "JS/Redux/RetiredContent";

export const service = new RetiredContentService();

export const useRetiredContent = (
    contentTypes: string,
    skip: boolean = false,
    isUpdateRequired: boolean = false,
) => {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useAppDispatch();
    const { mediaEssentials } = useGlobalMediaEssentials();

    const refetch = useCallback(() => {
        setLoading(true);

        return service
            .getRetiredContent(contentTypes)
            .then((res) => {
                const retiredContent = res?.data || [];

                dispatch(
                    contentTypes.includes("MP3")
                        ? setRetiredAudios(retiredContent)
                        : setRetiredVideos(retiredContent),
                );
            })
            .catch((err) => {
                enqueueSnackbar("Failed to fetch retired content", {
                    variant: "error",
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (
            !skip ||
            (mediaEssentials?.allow_rule_engine_requests && isUpdateRequired)
        ) {
            refetch();
        }
    }, [skip, isUpdateRequired]);

    return {
        refetch,
        loading,
    };
};
